import React, { useState , useEffect, useContext} from "react";
import { FormContext } from "../../context/FormContext";
import gmoLogo from '../../assets/images/gmo_logo.png'
import opvLogo from '../../assets/images/opticas-opv-logo.avif';
import ecoLogo from '../../assets/images/logo.svg';

const PopupReagendamientoReservada = ({ message, id_reserva }) => {
     const [secondsRemaining, setSecondsRemaining] = useState(15); // Inicia con 15 segundos
     const [isLoading, setIsLoading] = useState(true); // Estado para mostrar el loading
    // Verificación de la estructura del mensaje de reagendamiento
    //  console.log(message);
    const { formData }  = useContext(FormContext)
     
    const logos = {
        opv: opvLogo,  // Para formData.cadena === "opv"
        eco: ecoLogo,  // Para formData.cadena === "eco"
        default: gmoLogo // Para cualquier otro valor
      };
    
    const selectedLogo = logos[formData?.cadena] || logos.default;

    useEffect(() => {
      if (secondsRemaining > 0) {
        const timer = setInterval(() => {
          setSecondsRemaining((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(timer);
      } else {
        // Cuando el contador llegue a 0, recargar la página
        window.location.reload();
      }
    }, [secondsRemaining]);

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ maxWidth: "700px" }}
      >
        <div className="modal-content modal-succes">
          <div className="modal-body body-cita-confirmada">
            <div className="row">
              <div className="col-8">
                <p className="fs-6">
                  Número de cita:{" "}
                  <span className="fw-bold text-primary">#{id_reserva}</span>
                </p>
                <div
                  dangerouslySetInnerHTML={{ __html: message }} // Acceder a message.message
                />
                {isLoading && (
                  <p className="popup-loading">
                    Serás redirigido a la página principal en {secondsRemaining} segundos...
                  </p>
                )}
              </div>
              {/* Columna de Imagen */}
              <div className="col-4 d-flex col-logo-popup">
                {formData?.cadena === "opv" ? (
                  <>
                    <img
                      src={selectedLogo} // Logo dinámico
                      alt="GMO logo"
                      className="img-fluid"
                      style={{ maxWidth: "200px", maxHeight: "30px" }}
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={selectedLogo} 
                      alt="GMO logo"
                      className="img-fluid"
                      style={{ maxWidth: "100px", maxHeight: "30px" }}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupReagendamientoReservada;
